import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { CustomToastComponent } from "@/components/shared";
import { useMutation } from "@apollo/client/react";
import { RequestRecalculationDocument, RequestRecalculationMutation, RequestRecalculationMutationVariables } from "@/graphql/__generated__/graphql";

export default function useRequestRecalculationMutationHook(tenderID: string | undefined) {
  const { t } = useTranslation(["toasts"]);
  const navigate = useNavigate();

  const [requestRecalculationMutation, { loading, error }] = useMutation<RequestRecalculationMutation, RequestRecalculationMutationVariables>(
    RequestRecalculationDocument, {
      onCompleted() {
        toast(CustomToastComponent, {
          toastId: "request-recalculation-success",
          data: {
            title: t("toasts.recalculationrequested"),
            type: "success",
          }
        });
        navigate(`/tender/${tenderID}/services/all`);
      },
      refetchQueries: ["FetchTenderById"]
    });

  return {
    requestRecalculationMutation,
    loading,
    error
  };
}
